import { getSkillNotationNumber } from "../Pages/Student/StarNote/StarNote.constants";

export const getSkillNotation = (pointAcquired, totalPoint) => {
  return `${getSkillNotationNumber(pointAcquired, totalPoint)}/5`;
};

export const getSkillNotationPdf = (pointAcquired, totalPoint) => {
  return totalPoint !== 0 ? Math.round((pointAcquired / totalPoint) * 100) : 0;
};
